import { make } from "vuex-pathify";

const state = {
  hubAppEventSource: null,
  hubAppEvent: {},
  hubAppDisconnected: false
};

const mutations = make.mutations(state);

const actions = {
  ...make.actions(state),
  async startHubSSE({ commit }: { commit: Function }): Promise<void> {
    if (
      state.hubAppEventSource == undefined ||
      (state.hubAppEventSource as any).readyState == 2
    ) {
      const evtSource = new EventSource("http://127.0.0.1:8085/SSE");
      evtSource.addEventListener("event", (e: any) => {
        state.hubAppEvent = {};
        state.hubAppEvent = JSON.parse(e.data);
      });
      commit("SET_HUB_APP_EVENT_SOURCE", evtSource);
    }
  }
};

const getters = {
  ...make.getters(state)
};

export default {
  state,
  mutations,
  actions,
  getters
};
